export default "__VITE_ASSET__DrjkJR1M__"